import { Collection }       from '@mathquis/modelx';
import { ConnectorResults } from '@mathquis/modelx';
import { Model }            from '@mathquis/modelx';

export class CsvCollection<T extends Model = Model> extends Collection<T> {
  public csv: any;
  public data: any;

  public filters: Record<string, any> = {
    itemsPerPage: 1000,
    // pagination: false,
  };

  public sorts: Record<string, 'asc' | 'desc'> = {};

  public total = 0;

  public onListSuccess(results: ConnectorResults, options: object) {
    const connectorResults = new ConnectorResults([], results.res);
    this.csv = results.res.data;
    this.data = connectorResults.res.data;
    super.onListSuccess(connectorResults, options);
  }

  public prepareListOptions(options: object = {}) {
    const sorts: Record<string, 'asc' | 'desc'> = {};
    Object.keys(this.sorts).forEach(key => {
      if (key) {
        sorts[`order[${key}]`] = this.sorts[key];
      }
    });

    return super.prepareListOptions({
      filters: {
        ...this.filters,
        ...sorts,
      },
      // sort: this.sorting,
      ...options,
    });
  }

  public setFilter(field: string, value: any) {
    this.filters[field] = value;

    return this;
  }

  public setFilters(filters: Record<string, any>) {
    Object.keys(filters).forEach(key => {
      this.setFilter(key, filters[key]);
    });

    return this;
  }

  public setSort(field: string, asc = true) {
    this.sorts[field] = asc ? 'asc' : 'desc';

    return this;
  }

  public setSorts(sorts: Record<string, boolean> = {}) {
    Object.keys(sorts).forEach(key => {
      this.setSort(key, sorts[key]);
    });

    return this;
  }
}
